import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useSiteConfig } from "@/context/SiteConfigContext";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const tiers = [
  { key: "premium", label: "Premium partners" },
  { key: "partner", label: "Partners" },
  { key: "academic", label: "Academische partners" },
];

export default function Partners() {
  const { config } = useSiteConfig();
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    api.get("/partners").then((r) => setPartners(r.data)).catch(() => {});
  }, []);

  const partnerEmails = (config.partner_emails || "").split(",").map((e) => e.trim()).filter(Boolean);

  return (
    <div data-testid="partners-page">
      <PageHero
        eyebrow="Samen sterker"
        title={<>Onze<br />partners.</>}
        subtitle="Toonaangevende advocatenkantoren, bedrijven en universiteiten die ELSA Brussel mee mogelijk maken."
        testid="partners-hero"
      />
      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 py-24 space-y-20">
        {tiers.map((tier) => {
          const items = partners.filter((p) => p.tier === tier.key);
          if (items.length === 0) return null;
          return (
            <div key={tier.key}>
              <Reveal>
                <div className="flex items-center gap-4 mb-8">
                  <span className="h-2 w-2 rounded-full" style={{ background: "var(--elsa-blue)" }} />
                  <h2 className="text-sm tracking-[0.25em] uppercase text-muted-foreground">{tier.label}</h2>
                </div>
              </Reveal>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-px bg-black/10 border border-black/10">
                {items.map((p, i) => (
                  <Reveal key={p.id} delay={(i % 3) * 0.06}>
                    <a href={p.website || "#"} target="_blank" rel="noreferrer" className="group bg-white h-40 grid place-items-center px-6 transition-colors hover:bg-[#F9F9F6]" data-testid={`partner-${tier.key}-${i}`}>
                      {p.logo_url ? (
                        <img src={p.logo_url} alt={p.name} className="max-h-14 max-w-[70%] object-contain grayscale group-hover:grayscale-0 transition-all duration-500" />
                      ) : (
                        <span className="font-serif text-2xl md:text-3xl text-[#0A3087]/40 group-hover:text-[#0A3087] transition-colors">{p.name}</span>
                      )}
                    </a>
                  </Reveal>
                ))}
              </div>
            </div>
          );
        })}

        <Reveal>
          <div className="mt-8 p-10 md:p-16 text-white grain relative overflow-hidden" style={{ background: "var(--elsa-blue)" }}>
            <div className="relative z-10 max-w-2xl">
              <h3 className="font-serif text-3xl md:text-5xl mb-4">Partner worden?</h3>
              <p className="text-white/80 mb-6">Bereik gemotiveerde rechtenstudenten en bouw mee aan de volgende generatie juristen. Neem contact op voor onze partnerpakketten.</p>
              <div className="flex flex-wrap gap-4" data-testid="partner-contact-emails">
                {partnerEmails.map((email) => (
                  <a key={email} href={`mailto:${email}`} className="inline-flex items-center text-sm font-600 px-6 py-3 rounded-full bg-white text-[#0A3087] transition-transform hover:-translate-y-0.5">
                    {email}
                  </a>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
